export const triggerOpenModal = (controller) => {
  const modal = document.querySelector("[data-controller='modal']")
  if (modal) {
    document.dispatchEvent(new CustomEvent("modal:open"))
    document.getElementById("active-modal").setAttribute("data-controller", controller)
  }
}

const openModalAndDispatch = (controller, eventName, detail) => {
  triggerOpenModal(controller)
  const el = document.querySelector(`[data-controller='${controller}']`)
  if (el) {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent(eventName, { detail }))
    }, 20)
  }
}

export const addToCart = (songVersionData, options = {}) => {
  triggerOpenModal('cart')
  const cart = document.querySelector("[data-controller='cart']");
  if (cart) {
    // Allow the cart controller to connect before dispatching to event listener
    setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent("cart:form", { detail: { songVersionId: songVersionData.id } })
      )
    }, 20)
  }
}

export const handleCustomLicenseRequest = (songVersionData, options = {}) => {
  triggerOpenModal('custom-request')
  const form = document.querySelector("[data-controller='custom-request']");
  if (form) {
    // Allow the custom-request controller to connect before dispatching to event listener
    setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent("custom_request:form", { detail: { songVersionId: songVersionData.id } })
      )
    }, 20)
  }
}
  
export const customizeSongRequest = (songVersionId) => {
  triggerOpenModal('customize')
  const customizeForm = document.querySelector("[data-controller='customize']");
  if(customizeForm) {
    setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent("customize:form", { detail: { songVersionId: songVersionId } })
      ), 20 
    })
  }
}

export const addToMixtape = (songVersionId) => {
  openModalAndDispatch("mixtapes", "mixtapes:form", { songVersionId })
}

export const editMixtape = (mixtapeId) => {
  openModalAndDispatch("mixtapes", "mixtapes:edit", { mixtapeId })
}

export const deleteMixtape = (mixtapeId) => {
  openModalAndDispatch("mixtapes", "mixtapes:confirm_delete", { mixtapeId })
}

export const addToProjectSearch = (svId, songId) => {
  openModalAndDispatch("searches", "searches:form", { songVersionId: svId, songId })
}